interface Props {
    statusFilter: string;
    onStatusChange: (status: string) => void;
    statusCounts: Record<string, any>;
}

const STATUSES = [
    { value: 'PROCESSING', label: 'Processando' },
    { value: 'COMPLETED', label: 'Concluído' },
    { value: 'COMPLETED_WITH_FAILURES', label: 'Concluído com falhas' },
];

const cnt = (statusCounts: Record<string, any>, key: string): number => {
    const v = statusCounts[key];
    if (!v) return 0;
    return typeof v === 'object' ? v.count : v;
};

const lbl = (statusCounts: Record<string, any>, key: string, fallback: string): string => {
    const v = statusCounts[key];
    return v && typeof v === 'object' && v.label ? v.label : fallback;
};

const CreditRightBatchFilterSidebar = ({ statusFilter, onStatusChange, statusCounts }: Props) => {
    const totalAll = Object.values(statusCounts).reduce(
        (a: number, b: any) => a + (typeof b === 'object' ? b.count : b || 0), 0,
    );

    return (
        <div className="space-y-4">
            <button onClick={() => onStatusChange('')}
                className={`w-full text-left px-3 py-2 rounded-lg text-sm transition-colors ${!statusFilter
                    ? 'bg-blue-100 dark:bg-blue-900 text-blue-700 dark:text-blue-300 font-medium'
                    : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-slate-700'}`}>
                <div className="flex items-center justify-between">
                    <span>Todos</span>
                    <span className="text-xs text-gray-500 dark:text-gray-400">{totalAll}</span>
                </div>
            </button>

            <div className="border-t border-gray-200 dark:border-slate-700 pt-3">
                <div className="text-xs font-medium text-gray-500 dark:text-gray-400 mb-2 px-3">STATUS</div>
                <div className="space-y-1">
                    {STATUSES.map(s => (
                        <button key={s.value} onClick={() => onStatusChange(statusFilter === s.value ? '' : s.value)}
                            className={`w-full text-left px-3 py-2 rounded-lg text-sm transition-colors ${statusFilter === s.value
                                ? 'bg-blue-100 dark:bg-blue-900 text-blue-700 dark:text-blue-300 font-medium'
                                : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-slate-700'}`}>
                            <div className="flex items-center justify-between">
                                <span>{lbl(statusCounts, s.value, s.label)}</span>
                                <span className="text-xs text-gray-500 dark:text-gray-400">{cnt(statusCounts, s.value)}</span>
                            </div>
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default CreditRightBatchFilterSidebar;
